import type {
  AgentSelection,
  ActionType,
  ChatPendingMessageRemovedAction,
  ChatPendingMessageSetAction,
  Message,
  MessageKind,
  MessageAttachment,
  ModelSelection,
  PendingMessageKind,
} from '@microsoft/agent-host-protocol'

export type ContributedInstructionsMetadata = ReadonlyArray<{
  readonly kind: 'personal' | 'repository' | 'organization'
  readonly label?: string
  readonly ownerUrl?: string
}>

const ACTION_PENDING_MESSAGE_SET = 'chat/pendingMessageSet' as ActionType.ChatPendingMessageSet
const ACTION_PENDING_MESSAGE_REMOVED = 'chat/pendingMessageRemoved' as ActionType.ChatPendingMessageRemoved
const MESSAGE_KIND_USER = 'user' as MessageKind.User

export function buildUserMessage(
  text: string,
  attachments?: MessageAttachment[],
  model?: ModelSelection,
  agent?: AgentSelection,
  contributedInstructions?: ContributedInstructionsMetadata,
): Message {
  return {
    text,
    origin: {kind: MESSAGE_KIND_USER},
    ...(attachments && attachments.length > 0 ? {attachments} : {}),
    ...(model ? {model} : {}),
    ...(agent ? {agent} : {}),
    ...(contributedInstructions !== undefined
      ? {_meta: {'github.contributedInstructions': contributedInstructions}}
      : {}),
  }
}

export function buildPendingMessageSetAction(
  kind: PendingMessageKind,
  text: string,
  attachments?: MessageAttachment[],
  model?: ModelSelection,
  id: string = crypto.randomUUID(),
  agent?: AgentSelection,
  contributedInstructions?: ContributedInstructionsMetadata,
): ChatPendingMessageSetAction {
  const message = buildUserMessage(text, attachments, model, agent, contributedInstructions)
  return {
    type: ACTION_PENDING_MESSAGE_SET,
    kind,
    id,
    message: {
      ...message,
      _meta: {...message._meta, 'github.queuedMessageId': id},
    },
  }
}

export function buildPendingMessageRemovedAction(
  kind: PendingMessageKind,
  id: string,
): ChatPendingMessageRemovedAction {
  return {
    type: ACTION_PENDING_MESSAGE_REMOVED,
    kind,
    id,
  }
}
